import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_EMAILSTATUSTEMPLATE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.statusTemplate = payload
  },
  [types.SET_EMAILSTATUSTEMPLATES] (state, payload) {
    state.statusTemplates = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
